export const DEV_AMPLITUDE_APIKEY = 'd0baaa67671a694012f8148ca07a6b8c'
export const PROD_AMPLITUDE_APIKEY = '6e3c59bf5fba9aad8e18636004359b65'